<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <div
      slot="header"
      class="flex flex-wrap-reverse items-center flex-grow justify-between"
    >
      <div class="flex flex-wrap-reverse items-center">
        <vs-button
          type="filled"
          icon-pack="feather"
          icon="icon-plus"
          @click="
            $router.push(`/solicitacao/nova-solicitacao`).catch((err) => {})
          "
          class="
            p-3
            mb-4
            mr-4
            rounded-lg
            cursor-pointer
            flex
            items-center
            justify-between
            bg-success
          "
          >Nova Solicitação</vs-button
        >
      </div>
    </div>
    <vue-good-table
      ref="my-table"
      selectionInfoClass="mytable"
      style="width: 100%"
      styleClass="vgt-table condensed"
      :search-options="{
        enabled: true,
        trigger: '',
        placeholder: 'Procurar',
        skipDiacritics: true,
      }"
      :pagination-options="paginationOptions"
      :columns="columns"
      :rows="partsRequest"
      @on-row-click="onRowClick"
    >
      <div slot="emptystate" class="text-center">
        Nenhum resultado encontrado
      </div>
      <template slot="table-row" slot-scope="partsRequest">
        <span
          class="font-medium"
          @click.stop="open(partsRequest.row.idPartsRequest)"
          v-if="partsRequest.column.field == 'idPartsRequest'"
        >
          <vs-chip color="#1E90FF">{{
            partsRequest.row.idPartsRequest
          }}</vs-chip>
        </span>
        <span
          @click.stop="open(partsRequest.row.idPartsRequest)"
          class="font-medium"
          v-if="partsRequest.column.field == 'date'"
        >
          {{ partsRequest.row.date }}
        </span>
        <span
          class="font-medium"
             @click.stop="open(partsRequest.row.idPartsRequest)"
          v-if="partsRequest.column.field == 'userName'"
        >
          {{ partsRequest.row.userName }}
        </span>
        <span class="font-medium" v-if="partsRequest.column.field == 'stage'">
          <div v-if="partsRequest.row.stage == 'Conferência'">
            <vs-button
              @click.stop="openStage(partsRequest.row.idPartsRequest)"
              color="#1E90FF"
              type="flat"
              >{{ partsRequest.row.stage }}</vs-button
            >
          </div>
          <div v-show="partsRequest.row.stage == 'Entregue ao Solicitante'">
            <vs-button
              @click.stop="openStage(partsRequest.row.idPartsRequest)"
              color="success"
              type="flat"
              >{{ partsRequest.row.stage }}</vs-button
            >
          </div>

          <div v-show="partsRequest.row.stage == 'Concluído'">
            <vs-button
              @click.stop="openStage(partsRequest.row.idPartsRequest)"
              color="warning"
              type="flat"
              >{{ partsRequest.row.stage }}</vs-button
            >
          </div>
        </span>
        <span
          class="font-medium"
          v-if="partsRequest.column.field == 'createAt'"
        >
          {{ partsRequest.row.createAt }}
        </span>
        <span v-if="partsRequest.column.field === 'action'">
          <div align="center">
            <vs-dropdown vs-custom-content vs-trigger-click>
              <a
                class="flex items-center"
                style="font-weight: 500; font-size: 1rem"
                href="#"
              >
                Mais <i class="material-icons"> expand_more </i>
              </a>
              <vs-dropdown-menu class="w-48">
                <vs-dropdown-item
                  @click="duplicate(partsRequest.row.idPartsRequest)"
                >
                  <font-awesome-icon :icon="['far', 'copy']" class="w-4" />
                  Duplicar
                </vs-dropdown-item>
                <vs-dropdown-item
                  @click="report(partsRequest.row.idPartsRequest)"
                >
                  <font-awesome-icon :icon="['far', 'file-pdf']" class="w-4" />
                  Visualizar
                </vs-dropdown-item>
                <vs-dropdown-item
                  divider
                  @click="showPoupUp(partsRequest.row.idPartsRequest)"
                >
                  <font-awesome-icon :icon="['far', 'trash-alt']" class="w-4" />
                  Excluir
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </span>
      </template>
    </vue-good-table>
    <vs-popup class="Confirmar" title="Remover" :active.sync="popupActive">
      <p>Tem certeza que deseja remover esse item para lixeira?</p>
      <div class="vx-row">
        <div class="vx-col w-full mt-5">
          <vs-button
            color="danger"
            type="filled"
            icon-pack="feather"
            icon="icon-trash-2"
            @click="deleteData()"
            class="float-right"
            >Remover</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

 
<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import { VueGoodTable } from "vue-good-table";
export default {
  components: { VueGoodTable },
  data() {
    return {
      partsRequest: [],
      itemsPerPage: 100,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      columns: [],
      popupActive: false,
      idDelete: null,
      paginationOptions: {
        enabled: true,
        nextLabel: "Próxima",
        prevLabel: "Anterior",
        rowsPerPageLabel: "Resultados por página",
        ofLabel: "de",
        pageLabel: "Página",
        allLabel: "Todos",
        mode: "pages",
        perPage: 50,
      },
    };
  },
  computed: {},
  methods: {
     async report(idPartsRequest) {
      this.$vs.loading();
      try {
        let res = await axios.get(
          `${baseApiUrl}/partsRequest/report?idPartsRequest=${idPartsRequest}`,
          {
            responseType: "blob",
          }
        );
        let blob = new Blob([res.data], { type: "application/pdf" });
        let url = window.URL.createObjectURL(blob);
        window.open(url);
      } catch (error) {
        console.log(error);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async showPoupUp(idPartsRequest) {
      this.popupActive = true;
      this.idDelete = idPartsRequest;
    },
    async duplicate(idPartsRequest) {
      this.$vs.loading();
      try {
        const response = await axios.post(`${baseApiUrl}/partsRequest/duplicate`, {
          idPartsRequest,
        });
        this.popupActive = false;
      } catch (error) {
        console.log(error);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        await this.getAllPartsRequest();
        this.$vs.loading.close();
        this.popupActive = false;
      }
    },
    async deleteData() {
      this.$vs.loading();
      let idPartsRequest =  this.idDelete;
      try {
        const response = await axios.post(`${baseApiUrl}/partsRequest/delete`, {
          idPartsRequest,
        });
        this.popupActive = false;
      } catch (error) {
        console.log(error);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        await this.getAllPartsRequest();
        this.$vs.loading.close();
        this.popupActive = false;
      }
    },
    open(idPartsRequest) {
      this.$router
        .push(`/solicitacao/editar/${idPartsRequest}`)
        .catch((err) => {});
    },
    openStage(idPartsRequest) {
      this.$router
        .push(`/solicitacao/etapa/${idPartsRequest}`)
        .catch((err) => {});
    },
    async getAllPartsRequest() {
      this.$vs.loading();
      try {
        const response = await axios.get(
          `${baseApiUrl}/partsRequest/getAllPartsRequest`
        );
        this.partsRequest = response.data;
      } catch (error) {
        console.log(error);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    onRowClick(params) {
      // Somente para ter a mão do mouse clique
    },
    mountTable() {
      this.columns = [
        {
          label: "Código",
          field: "idPartsRequest",
          tdClass: "align-middle",
        },
        {
          label: "Data",
          field: "date",
          tdClass: "align-middle",
        },
        {
          label: "Técnico",
          field: "userName",
          tdClass: "align-middle",
        },
        {
          label: "Etapa",
          field: "stage",
          tdClass: "align-middle",
        },
        {
          label: "Ação",
          field: "action",
          tdClass: "align-middle",
        },
      ];
    },
  },
  async created() {
    await this.getAllPartsRequest();
    this.mountTable();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }
          &:focus + i {
            left: 1rem;
          }
        }
      }
    }
    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;
            span {
              display: flex;
              justify-content: flex-start;
            }
            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }
    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>